import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import Header from './Header/Header';

const ProtectedRoute = ({ element: Element, user, signOut, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadSession = async () => {
      try {
        // Simular la obtención de la sesión de usuario
      } catch (e) {
        console.error('Error fetching user session:', e);
      } finally {
        setIsLoading(false);
      }
    };

    if (user) {
      loadSession();
    }
  }, [user]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Header user={user} signOut={signOut} />
      <Element user={user} {...rest} />
    </>
  );
};

export default ProtectedRoute;
